import {ChangeDetectionStrategy, Component, computed, inject, Signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {NgOptimizedImage} from "@angular/common";
import {Router} from '@angular/router';
import {map, startWith} from 'rxjs';
import {LayoutService} from "../../../shared/services/layout.service";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {NgSrcImageErrorDirective} from '../../../shared/directives/ng-src-image-error.directive';
import {ModuleConfigurationService} from '../../../shared/services/module-configuration.service';

@Component({
    selector: 'app-global-footer',
    imports: [
    NgOptimizedImage,
    TranslatePipe,
    NgSrcImageErrorDirective
],
    templateUrl: './bar-global-footer.component.html',
    styleUrl: './bar-global-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalFooterComponent{
    public layoutService: LayoutService = inject(LayoutService);
    private moduleConfigurationService: ModuleConfigurationService = inject(ModuleConfigurationService);
    private router: Router = inject(Router);
    
    private currentUrl: Signal<string> = toSignal(
      this.router.events.pipe(
        map(() => this.router.url),
        startWith(this.router.url)
      ),
      {initialValue: this.router.url}
    );

    public showFooter: Signal<boolean> = computed(
      () => this.moduleConfigurationService.shouldShowFooterForRoute(this.currentUrl())
    );
}
